module.exports = __webpack_public_path__ + "img/banner-1.2c654cb3.jpg";